<template>
  <li class="coming-webinars__item">
    <a :href="`/${lang}/webinars/${filePath}/`" class="coming-webinars__link-card">
      <div class="coming-webinars__date-col coming-webinars__col _en">
        <div class="coming-webinars__date">{{ dateExpire }}</div>
        <div class="coming-webinars__time">{{ time }}</div>
      </div>
      <div class="coming-webinars__about coming-webinars__col">
        <div v-if="badge !== ''" class="coming-webinars__badge">{{ badge }}</div>
        <div class="coming-webinars__title">{{ title }}</div>
        <div class="coming-webinars__description">{{ description }}</div>
      </div>
      <div class="coming-webinars__info coming-webinars__col">
        <div class="coming-webinars__info-wrapper coming-webinars__info-zoom">
          <div class="coming-webinars__where">Zoom meeting</div>
          <div class="coming-webinars__duration">English, 45 minutes</div>
        </div>
      </div>
      <div class="coming-webinars__link coming-webinars__col">
        <span class="link-arrow">{{ coming ? translateMap.watch[lang] : translateMap.register[lang] }}</span>
      </div>
    </a>
  </li>
</template>

<script>
const translateMap = {
  register: {
    en: 'Register now',
    de: 'Jetzt anmelden'
  },
  watch: {
    en: 'Watch now',
    de: 'Schau jetzt'
  }
}

export default {
  name: "WebinarGlobalCard",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    dateExpire: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    filePath: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    },
    coming: Boolean,
    badge: String,
    soon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      translateMap
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/WebinarGlobalCard.vue